var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M0.666992 0.333252L6.00033 5.66659L11.3337 0.333252","fill":_vm.iconFill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }